// upload-http-service.ts
import axios from 'axios';
import { HTTP } from '@/services/http-service';

// Separate instance without the shared response interceptor, so upload errors
// (e.g. 413 Payload Too Large) reject normally and can be handled locally.
export const uploadHttp = axios.create({
  baseURL: window.autoProcessConfiguration.apiUrl,
  withCredentials: true
});

// Copy the CSRF token from the shared HTTP instance before each request,
// since this instance does not share HTTP's response interceptor that sets it.
uploadHttp.interceptors.request.use(config => {
  const token = HTTP.defaults.headers.common['x-csrf-token'];

  if (token) {
    config.headers['x-csrf-token'] = token;
  }

  return config;
});